import { ArrowUpRight } from "lucide-react";
import { FadeIn } from "./FadeIn";

const ARCHIVE = [
  {
    year: "2026",
    title: "Genesis",
    duration: "1:17",
    href: "https://open.spotify.com/track/6aZiFZfJHWGPvSRnZtV2ae?si=912a3f72cff9473e",
  },
  {
    year: "2026",
    title: "Elegy",
    duration: "2:00",
    href: "https://open.spotify.com/track/4O4P5PdRzAvyZkPWgNdxUM?si=8bd9c16f741e41fd",
  },
];

export const Archive = () => {
  return (
    <section
      id="archive"
      data-testid="archive-section"
      className="relative py-32 md:py-48 px-6 sm:px-10 md:px-16 border-t border-[#141414]"
    >
      <div className="max-w-7xl mx-auto">
        <FadeIn>
          <div className="flex items-center gap-4 mb-16 md:mb-24">
            <span className="kv-overline text-[#6b6b6b]">N° 02</span>
            <span className="h-px flex-1 bg-[#1a1a1a]" />
            <span className="kv-overline text-[#a3a3a3]">Archive</span>
          </div>
        </FadeIn>

        <FadeIn>
          <h2 className="font-serif-display text-[#f2f0e9] text-3xl sm:text-4xl md:text-5xl mb-3 italic">
            Selected works
          </h2>
          <p className="kv-overline text-[#6b6b6b] mb-16">
            2026 · Two entries · Click to listen
          </p>
        </FadeIn>

        <FadeIn duration={2.2}>
          <ol
            data-testid="archive-list"
            className="border-t border-[#1a1a1a]"
          >
            {ARCHIVE.map((entry, idx) => (
              <li
                key={entry.title}
                data-testid={`archive-row-${entry.year}-${entry.title.toLowerCase()}`}
                className="border-b border-[#141414]"
              >
                <a
                  href={entry.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Listen to ${entry.title} on Spotify`}
                  className="group grid grid-cols-12 gap-4 sm:gap-8 items-baseline py-6 sm:py-7 transition-colors duration-700 hover:bg-white/[0.02]"
                >
                  <span className="col-span-2 font-mono-archive text-xs sm:text-sm text-[#6b6b6b] tracking-wider">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="col-span-2 sm:col-span-2 font-mono-archive text-sm sm:text-base text-[#a3a3a3]">
                    {entry.year}
                  </span>
                  <span className="col-span-6 sm:col-span-6 font-serif-display text-lg sm:text-xl md:text-2xl italic text-[#f2f0e9] opacity-90 transition-all duration-700 group-hover:opacity-100 group-hover:translate-x-1">
                    {entry.title}
                  </span>
                  <span className="col-span-1 hidden sm:flex justify-end">
                    <ArrowUpRight
                      className="w-4 h-4 text-[#a3a3a3] opacity-0 -translate-x-2 transition-all duration-700 group-hover:opacity-70 group-hover:translate-x-0"
                      strokeWidth={1}
                      aria-hidden="true"
                    />
                  </span>
                  <span className="col-span-2 sm:col-span-1 text-right font-mono-archive text-xs sm:text-sm text-[#a3a3a3] group-hover:text-[#f2f0e9] transition-colors duration-700">
                    {entry.duration}
                  </span>
                </a>
              </li>
            ))}
          </ol>
        </FadeIn>

        <FadeIn delay={0.3} />
      </div>
    </section>
  );
};

export default Archive;
